export default __webpack_public_path__ + "static/media/Victoria_9781408300275.5f59ff81.jpg";